'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Search, User, ShoppingCart, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Accueil', href: '/' },
    { name: 'Applications', href: '/application' },
    { name: 'Tutoriels', href: '/tutorials' },
    { name: 'Abonnements', href: '/#subscriptions' },
    { name: 'BOX', href: '/product/firestick-promo' },
    { name: 'FAQ', href: '/#faq' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/70 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link href="/" className="flex items-center gap-2">
              <div className="relative w-32 h-10">
                <Image 
                  src="/img/esiptv-pro-logo.webp" 
                  alt="ESIPTV Pro Logo" 
                  fill
                  className="object-contain"
                  sizes="(max-width: 768px) 128px, 128px"
                  priority
                />
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                href={link.href}
                className="text-sm font-medium text-gray-300 hover:text-white transition-colors relative group"
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-500 transition-all group-hover:w-full"></span>
              </Link>
            ))}
          </nav>

          {/* Icons */}
          <div className="hidden md:flex items-center gap-6 text-gray-300">
            <button className="hover:text-white transition-colors">
              <Search className="w-5 h-5" />
            </button>
            <button className="hover:text-white transition-colors">
              <User className="w-5 h-5" />
            </button>
            <Link href="/checkout" className="hover:text-white transition-colors relative">
              <ShoppingCart className="w-5 h-5" />
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-4">
            <Link href="/checkout" className="text-gray-300 hover:text-white relative">
              <ShoppingCart className="w-5 h-5" />
            </Link>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-300 hover:text-white"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#0a0a0a] border-b border-white/10 overflow-hidden"
          >
            <div className="px-4 pt-2 pb-6 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block text-base font-medium text-gray-300 hover:text-white"
                >
                  {link.name}
                </Link>
              ))}
              <div className="pt-4 flex items-center gap-6 border-t border-white/10 text-gray-300">
                <button className="flex items-center gap-2 hover:text-white">
                  <Search className="w-5 h-5" /> Recherche
                </button>
                <button className="flex items-center gap-2 hover:text-white">
                  <User className="w-5 h-5" /> Compte
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
